<mainpanel [Title]="channelList.length > 0 ? 'Channel (' + channelList.length + ')' : 'Channel'" [hideSearchBox]="true" [hideSearchDropdown]="true">
    <div actions>
        <a role="button" title="Delete" class="btn btn-danger me-3"
        *ngIf="(getSelectedData().length > 0)"
        (click)="Delete()"><i
          class="fa fa-trash"></i> Delete</a>

        <a role="button" class="btn btn-success text-white"
        routerLink="/menu/channel/form">Add</a>
    </div>
    <div content>
        <div class="container-fluid mt-5">
            <div class="table-responsive">
                <table class="table">
                    <thead class="thead-light sticky-top-thead">
                        <tr>
                            <th style="width: 5px;">
                            </th>
                            <th>Subdomain</th>
                            <th>ClientIDGuid</th>
                            <th>ClientSecretGuiD</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of channelList" class="border-bottom">
                            <td>
                                <input type="checkbox" [(ngModel)]="item.selected">
                            </td>
                            <td>
                                <a [routerLink]="['/menu/channel/form']"
                                [queryParams]="{ID:item.ID}">{{item.SubDomain}}</a></td>
                            <td>{{item.ClientIDGuid}}</td>
                            <td>{{item.ClientSecretGuid}}</td>
                            <td>
                                <button 
                                    *ngIf="item.LoginID && item.Password; else placeholderBtn" 
                                    class="btn btn-success btn-sm me-2" 
                                    (click)="onLogin(item)">
                                    Sign In
                                </button>

                                <ng-template #placeholderBtn>
                                    <button class="btn btn-primary btn-sm me-2 invisible">Sign In</button>
                                </ng-template>
                                <button class="btn btn-success btn-sm" (click)="onVerifyChannel(item)">Verify</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</mainpanel>
